import { NavigateFunction } from 'react-router-dom';

// This is a workaround to allow navigation from Redux thunks and other places
// where we don't have access to the useNavigate hook.
// The navigate function is set when the App component mounts.
let navigateFunction: NavigateFunction | null = null;

export const setNavigate = (navigate: NavigateFunction) => {
    navigateFunction = navigate;
};

export const navigate = (to: string | { pathname: string }, options?: { replace?: boolean; state?: any }) => {
    if (!navigateFunction) {
        console.error('Navigate function not set. Make sure setNavigate is called in your App component.');
        return;
    }

    if (typeof to === 'string') {
        navigateFunction(to, options);
    } else {
        navigateFunction(to.pathname, options);
    }
};
